import { useState, useEffect, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import {GrantAccessToCompany} from './dialogs/grantAccessToCompany';
import { APIGetCompanyAssociates } from '../api/companies/Companies';
import {UserBadge} from "#src/helper/userHelper";
import {UserManagementMenu} from './userManagementMenu';
export const UserManagement = ({ limit, userRole, company }) => {
    const { user } = useContext(UserContext);
    const [show, setShow] = useState(false);
    const [associates, setAssociates] = useState([]);

    const accessOptions = [
        {id: 1, value: 'admin', name: 'Admistrator'},
        {id: 2, value: 'user', name: 'Benutzer'},
    ]

    const fetchAssociates = async () => {
        try {
            const companyAssociates = await APIGetCompanyAssociates(user.companyId);
            if (!companyAssociates) {
                throw new Error('Error: Could not load company associates');
            }
            setAssociates(companyAssociates);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchAssociates();
    }
    , []);

    return (
        <div className="border border-gray-500 rounded-lg  bg-white w-full mb-8 p-6">
            {show && <GrantAccessToCompany 
                show={show} 
                setShow={setShow}
                company={company}
                getAssociates={fetchAssociates}
            />}
            <div className="flex justify-between flex justify-between rounded pb-5 ">
                <h1 className="text-lg font-semibold text-lg text-gray-900">
                    <span >Zugriff</span><span className='font-medium ml-1 self-end pb-[1px]'>({associates?.length}/{limit})</span>
                </h1>
                {(userRole === 'admin' && limit > associates?.length) && (
                    <button
                        onClick={() => setShow(true)}
                        type="button"
                        className="block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        Einladen
                    </button>
                )}
            </div>
            <div className='flex flex-col'>
                {associates.map((associate, index) => {
                    return (
                        <div key={index} className="flex justify-between items-center p-2 hover:bg-gray-200">
                            <div className='flex items-center gap-4'>
                                <div>
                                    {UserBadge(associate.user_name, associate.user_name, 8, 'xs')}
                                </div>
                                <div className='flex flex-col gap-1'>
                                    <div>
                                        {associate.user_name || 'Unbekannt'}
                                    </div>
                                    <div className='text-xs font-light text-gray-550'>
                                        {associate.user_email}
                                    </div>
                                </div>
                            </div>
                            <div className='flex items-center gap-4'>
                                <div className='text-sm text-gray-600'>
                                    {accessOptions.find( option => option.value ===associate.permission).name}
                                </div>
                                <UserManagementMenu associate={associate} getAssociates={fetchAssociates} associates={associates}/>
                            </div>
                        </div>
                    )
                }
                )}
            </div>
        </div>
    );
}
